import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { AccountListProvider } from '../context/AccountListContext';
import GlobalContactsWrapper from '../components/Frontend/GlobalContacts/GlobalContactsWrapper';

export const globalContactsRoutes = (
  <Route path="/global_contacts" element={<MainLayout />}>
    <Route path="" element={
      <AccountListProvider> <GlobalContactsWrapper /></AccountListProvider>} />
  </Route>
);
